import TablaConciliacion from "../../../TablaConciliacion";

function TablaRutaDelCacao() {
  return <TablaConciliacion nombreUseCase="RUTADELCACAO" titulo="RUTA DEL CACAO" />;
}

export default TablaRutaDelCacao;
